(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fuelme-detail-nutrition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fuelme-detail-nutrition')) {
    class FuelmeDetailNutrition extends HTMLElement {
      connectedCallback() {
        if (this.dataset.fdNutritionReady) return;
        const controls = this.querySelector('[data-fd-nutrition-controls]');
        if (!controls) return;
        this.dataset.fdNutritionReady = 'true';
        controls.hidden = false;
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-fd-nutrition-basis]');
          if (!button || !controls.contains(button)) return;
          const basis = button.dataset.fdNutritionBasis;
          if (!['serving', 'snack', 'prepared'].includes(basis)) return;
          controls.querySelectorAll('button[data-fd-nutrition-basis]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
          this.querySelectorAll('[data-fd-basis-value]').forEach((value) => {
            value.hidden = value.dataset.fdBasisValue !== basis;
          });
        });
      }
    }
    customElements.define('fuelme-detail-nutrition', FuelmeDetailNutrition);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuelme-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fuelme-health-guide')) return;

  class FuelmeHealthGuide extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onInput = this._onInput.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onLocationChange = this._onLocationChange.bind(this);
      this._savedOpenStates = new Map();
    }

    connectedCallback() {
      if (this._connected) return;
      // A section can be inserted by the theme editor after this element is defined.
      if (!this._initialize()) {
        this._connectFrame = requestAnimationFrame(() => {
          if (this.isConnected) this._initialize();
        });
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._connectFrame);
      cancelAnimationFrame(this._navigationFrame);
      cancelAnimationFrame(this._locationFrame);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('input', this._onInput);
      this.removeEventListener('keydown', this._onKeydown);
      window.removeEventListener('hashchange', this._onLocationChange);
      window.removeEventListener('popstate', this._onLocationChange);
      this._restoreOpenStates();
      this._connected = false;
    }

    _initialize() {
      if (this._connected) return true;
      this._groups = Array.from(this.querySelectorAll('.hf-group[data-group]'));
      if (!this._groups.length) return false;
      this._categories = Array.from(this.querySelectorAll('[data-hf-category]'));
      this._topics = Array.from(this.querySelectorAll('.hf-topic'));
      this._questions = Array.from(this.querySelectorAll('details.hf-question'));
      this._search = this.querySelector('[data-hf-search]');
      this._clear = this.querySelector('[data-hf-clear]');
      this._status = this.querySelector('[data-hf-status]');
      this._empty = this.querySelector('[data-hf-empty]');
      this._results = this.querySelector('[data-hf-results]');
      this._searchText = new Map(this._questions.map(question => [question, this._normalize(question.textContent)]));
      this._selected = this._groups.some(group => group.dataset.group === this._selected)
        ? this._selected
        : (this._groups.some(group => group.dataset.group === 'basics') ? 'basics' : this._groups[0].dataset.group);
      this._searching = false;
      this._connected = true;
      this.addEventListener('click', this._onClick);
      this.addEventListener('input', this._onInput);
      this.addEventListener('keydown', this._onKeydown);
      window.addEventListener('hashchange', this._onLocationChange);
      window.addEventListener('popstate', this._onLocationChange);
      if (this._status) {
        this._status.setAttribute('role', 'status');
        this._status.setAttribute('aria-live', 'polite');
        this._status.setAttribute('aria-atomic', 'true');
      }
      this.classList.add('is-ready');
      const hashHandled = this._applyHash({ scroll: location.hash !== '#faq', focus: false });
      if (!hashHandled) {
        this._showSelectedGroup();
        if (this._search && this._normalize(this._search.value)) this._runSearch();
      }
      return true;
    }

    _normalize(value) {
      return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().replace(/ł/g, 'l').replace(/ø/g, 'o').replace(/ß/g, 'ss')
        .replace(/\s+/g, ' ').trim();
    }

    _onClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!target) return;
      const category = target.closest('[data-hf-category]');
      if (category && this.contains(category) && this._groups.some(group => group.dataset.group === category.dataset.hfCategory)) {
        event.preventDefault();
        this._selectCategory(category.dataset.hfCategory, { updateHash: true, scroll: true, focus: true });
        return;
      }
      const clear = target.closest('[data-hf-clear], [data-hf-reset]');
      if (clear && this.contains(clear)) {
        event.preventDefault();
        this._clearSearch();
        if (this._search) this._search.focus({ preventScroll: true });
      }
    }

    _onInput(event) {
      if (event.target === this._search) this._runSearch();
    }

    _onKeydown(event) {
      if (event.target === this._search && event.key === 'Escape' && this._search.value) {
        event.preventDefault();
        this._clearSearch();
      }
    }

    _onLocationChange() {
      // Back/forward navigation may emit both events; handle their shared hash once.
      cancelAnimationFrame(this._locationFrame);
      this._locationFrame = requestAnimationFrame(() => this._applyHash({ scroll: true, focus: true }));
    }

    _applyHash({ scroll = true, focus = false } = {}) {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return false; }
      if (!id) return false;
      let target;
      let group;
      if (id === 'faq') {
        target = this.closest('#faq') || this;
        group = this._groups.find(item => item.dataset.group === this._selected);
      } else {
        target = document.getElementById(id);
        if (!target || !this.contains(target)) return false;
        group = target.matches('.hf-group[data-group]') ? target : target.closest('.hf-group[data-group]');
        if (!group || !this._groups.includes(group)) return false;
      }
      this._selectCategory(group.dataset.group);
      const question = target.closest('details.hf-question');
      if (question) question.open = true;
      if (scroll) this._navigateTo(target, focus ? group.querySelector('[data-hf-group-title]') : null);
      return true;
    }

    _selectCategory(key, { updateHash = false, scroll = false, focus = false } = {}) {
      const group = this._groups.find(item => item.dataset.group === key);
      if (!group) return;
      this._selected = key;
      this._clearSearch();
      if (updateHash) {
        const hash = '#faq-' + key;
        if (location.hash !== hash) history.replaceState(history.state, '', hash);
      }
      if (scroll) this._navigateTo(this._results || group, focus ? group.querySelector('[data-hf-group-title]') : null);
    }

    _navigateTo(target, focusTarget) {
      cancelAnimationFrame(this._navigationFrame);
      this._navigationFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !target || !target.isConnected) return;
        if (focusTarget) {
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    _runSearch() {
      const tokens = this._normalize(this._search ? this._search.value : '').split(' ').filter(Boolean);
      if (!tokens.length) {
        this._clearSearch();
        return;
      }
      // Capture the reader's accordion choices once, before search expands results.
      if (!this._searching) {
        this._questions.forEach(question => this._savedOpenStates.set(question, question.open));
      }
      this._searching = true;
      this.classList.add('is-searching');
      let count = 0;
      this._questions.forEach(question => {
        const matches = tokens.every(token => this._searchText.get(question).includes(token));
        question.hidden = !matches;
        question.open = matches;
        if (matches) count += 1;
      });
      this._topics.forEach(topic => {
        topic.hidden = !Array.from(topic.querySelectorAll('details.hf-question')).some(question => !question.hidden);
      });
      this._groups.forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('details.hf-question')).some(question => !question.hidden);
      });
      this._categories.forEach(category => category.removeAttribute('aria-current'));
      if (this._clear) this._clear.hidden = false;
      if (this._empty) this._empty.hidden = count > 0;
      if (this._status) {
        const template = this._status.dataset.template || '{count} answers found';
        this._status.textContent = count
          ? template.replace(/\{\{\s*count\s*\}\}|\{count\}/g, String(count))
          : (this._status.dataset.empty || 'No answers found. Try another word.');
        this._status.hidden = false;
      }
    }

    _restoreOpenStates() {
      this._savedOpenStates.forEach((open, question) => { question.open = open; });
      this._savedOpenStates.clear();
    }

    _clearSearch() {
      if (this._search) this._search.value = '';
      this._restoreOpenStates();
      this._searching = false;
      this.classList.remove('is-searching');
      this._questions.forEach(question => { question.hidden = false; });
      this._topics.forEach(topic => { topic.hidden = false; });
      if (this._clear) this._clear.hidden = true;
      if (this._empty) this._empty.hidden = true;
      if (this._status) {
        this._status.textContent = '';
        this._status.hidden = true;
      }
      this._showSelectedGroup();
    }

    _showSelectedGroup() {
      this._groups.forEach(group => { group.hidden = group.dataset.group !== this._selected; });
      this._categories.forEach(category => {
        if (category.dataset.hfCategory === this._selected) category.setAttribute('aria-current', 'true');
        else category.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('fuelme-health-guide', FuelmeHealthGuide);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuelme-studio-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.fm-launch-header .fm-mobile-menu');
    if (menu && event.target.closest('a')) menu.removeAttribute('open');
    if (!menu) document.querySelectorAll('.fm-launch-header .fm-mobile-menu[open]').forEach(item => item.removeAttribute('open'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fm-launch-header .fm-mobile-menu[open]').forEach(item => {
      item.removeAttribute('open');
      item.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.fm-launch-header .fm-mobile-menu[open]').forEach(item => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });
  window.matchMedia('(min-width:1100px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelectorAll('.fm-launch-header .fm-mobile-menu[open]').forEach(item => item.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuelme-studio-hero"] && !Shopify.designMode) return;
  try {
    
  class FuelmeCampaign extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[data-fm-hero-tab]')];
      if (!tabs.length) return;
      this.querySelector('[data-fm-hero-controls]').hidden = false;
      const select = tab => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector('#' + CSS.escape(item.getAttribute('aria-controls'))).hidden = !active;
        });
        this.style.setProperty('--fm-bg', tab.dataset.background);
        this.style.setProperty('--fm-ink', tab.dataset.ink);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next]);
          tabs[next].focus();
        });
      });
    }
  }
  if (!customElements.get('fuelme-campaign')) customElements.define('fuelme-campaign', FuelmeCampaign);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
